import { IPropertyEnvironmentOptionView, PropertyEnvironmentOptionView } from './property-environment-option-view.model';

export interface IPropertyEnvironmentPoint {
    Id?: number
    PoiMapId?: number
    ObjectId?: number
    Object_Latitude?: number
    Object_Longitude?: number
    POI_Id?: number
    POI_Latitude?: number
    POI_Longitude?: number
    POI_Type?: string
    POI_Name?: string
    POI_Address?: string
    GroupCode?: string
    Distance?: number | string
    TravelTime?: number
    Radius?: number
    ViewOnMap?: Boolean
    RoutePolyline?: string
    GoogleDistance?: number
    GoogleDistanceText?: string
    GoogleDuration?: number
    GoogleDurationText?: string
    TravelMode?: string
    LastUpdate?: number
    PoiTime_Latitude?: number
    PoiTime_Longitude?: number
    IconUrl?: string
}

export class PropertyEnvironmentPoint implements IPropertyEnvironmentPoint {
    Id?: number
    PoiMapId?: number
    ObjectId?: number
    Object_Latitude?: number
    Object_Longitude?: number
    POI_Id?: number
    POI_Latitude?: number
    POI_Longitude?: number
    POI_Type?: string
    POI_Name?: string
    POI_Address?: string
    GroupCode?: string
    Distance?: number | string
    TravelTime?: number
    Radius?: number
    ViewOnMap?: Boolean
    RoutePolyline?: string
    GoogleDistance?: number
    GoogleDistanceText?: string
    GoogleDuration?: number
    GoogleDurationText?: string
    TravelMode?: string
    LastUpdate?: number
    PoiTime_Latitude?: number
    PoiTime_Longitude?: number
    IconUrl?: string

    constructor(option: IPropertyEnvironmentPoint) {
        this.Id = option.Id
        this.PoiMapId = option.PoiMapId
        this.ObjectId = option.ObjectId
        this.Object_Latitude = option.Object_Latitude
        this.Object_Longitude = option.Object_Longitude
        this.POI_Id = option.POI_Id
        this.POI_Latitude = option.POI_Latitude
        this.POI_Longitude = option.POI_Longitude
        this.POI_Type = option.POI_Type
        this.POI_Name = option.POI_Name
        this.POI_Address = option.POI_Address
        this.GroupCode = option.GroupCode
        this.Distance = option.Distance
        this.TravelTime = option.TravelTime
        this.Radius = option.Radius
        this.ViewOnMap = option.ViewOnMap || false
        this.RoutePolyline = option.RoutePolyline
        this.GoogleDistance = option.GoogleDistance
        this.GoogleDistanceText = option.GoogleDistanceText
        this.GoogleDuration = option.GoogleDuration
        this.GoogleDurationText = option.GoogleDurationText
        this.TravelMode = option.TravelMode
        this.LastUpdate = option.LastUpdate
        this.PoiTime_Latitude = option.PoiTime_Latitude
        this.PoiTime_Longitude = option.PoiTime_Longitude
        this.IconUrl = option.IconUrl
    }
}

export interface IPropertyEnvironmentPointMapList {
    OptionView?: IPropertyEnvironmentOptionView
    Groups?:IPropertyEnvironmentPointMapViewGroup[]
}


export class PropertyEnvironmentPointMapList implements IPropertyEnvironmentPointMapList {
    OptionView?: IPropertyEnvironmentOptionView
    Groups?:IPropertyEnvironmentPointMapViewGroup[]
    constructor(option: IPropertyEnvironmentPointMapList) {
        this.OptionView = option.OptionView || new PropertyEnvironmentOptionView({})
        this.Groups = option.Groups || []
    }
}

export interface IPropertyEnvironmentPointMapViewGroup {
    Type?: string
    Pois?: IPropertyEnvironmentPoint[],
    //04-07
    GroupCode?: string
    GroupName?: IGroupName
    GroupPois?: IGroupPoint[] 
}

export class PropertyEnvironmentPointMapViewGroup implements IPropertyEnvironmentPointMapViewGroup {
    Type?: string
    Pois?: IPropertyEnvironmentPoint[]
    constructor(option: IPropertyEnvironmentPointMapViewGroup) {
        this.Type = option.Type
        this.Pois = option.Pois || []
    }
}

export interface IGroupName {
    NameEN?: string
    NameFR?: string
    NameNL?: string
}

export class GroupName implements IGroupName {
    NameEN?: string
    NameFR?: string
    NameNL?: string
    constructor(options: IGroupName) {
        this.NameEN = options.NameEN
        this.NameFR = options.NameFR
        this.NameNL = options.NameNL
    }
}

export interface ITypeName {
    NameEN?: string
    NameFR?: string
    NameNL?: string
}

export class TypeName implements ITypeName {
    NameEN?: string
    NameFR?: string
    NameNL?: string
    constructor(options: ITypeName) {
        this.NameEN = options.NameEN
        this.NameFR = options.NameFR
        this.NameNL = options.NameNL
    }
}

export interface IGroupPoint {
    IconUrl?: string
    TypeCode?: string
    TypeName?: ITypeName
    TypePois?: IPropertyEnvironmentPoint[]
}

export class GroupPoint implements IGroupPoint {
    IconUrl?: string
    TypeCode?: string
    TypeName?: ITypeName
    TypePois?: IPropertyEnvironmentPoint[]
    constructor(options: IGroupPoint) {
        this.IconUrl = options.IconUrl
        this.TypeCode = options.TypeCode
        this.TypeName = options.TypeName
        this.TypePois = options.TypePois
    }
}